import { TEXT_COLORS } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const ChangesTitleWrapper = styled.div`
    color: ${TEXT_COLORS.heading};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].fontWeight};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].lineHeight};
`;

export const ChangesDescWrapper = styled.div`
    color: ${TEXT_COLORS.body};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight};
    margin-bottom: -16px;
`;

export const ListItemWrapper = styled.div`
    max-width: 800px;
`;
